export const styleOverrides = {
  root: ({ theme }) => ({
    // Removed backgroundColor to allow component-level overrides
    "& .MuiInputBase-input": {
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      resize: "vertical",
      color: theme.palette.text.main,
    },
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : theme.palette.border.main,
        borderWidth: 1,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#4ade80",
      },
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#4ade80",
          borderWidth: "2px",
        },
      },
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75),
      paddingLeft: theme.spacing(1.25),
      paddingRight: theme.spacing(1.25),
    },
  }),
};
